import { Language, ThemeSwitcher, Message, Notification, ProfilePic, Hamburger } from "components"

// getting props from app component
export interface ProfileMainProps {
 colorMode: string
 modeChanger: () => void
}
export const ProfileMain = ({ colorMode, modeChanger }: ProfileMainProps) => {
 return (
  <>
   <div className="flex items-center justify-between lg:gap-4 gap-1 mx-2 lg:mx-5">
    {/* calling all child component */}
    <div className="lg:w-fit w-[15%]">
     <Language />
    </div>
    <div className="lg:w-fit w-[15%]">
     <ThemeSwitcher colorMode={colorMode} modeChanger={modeChanger} />
    </div>
    <div className="lg:w-fit w-[15%]">
     <Message />
    </div>
    <div className="lg:w-fit w-[15%]">
     <Notification />
    </div>
    <div className="lg:w-fit w-[15%]">
     {" "}
     <ProfilePic />
    </div>
    <div className="lg:w-fit w-[15%] lg:hidden">
     <Hamburger />
    </div>
   </div>
  </>
 )
}
